import { SET_GALLERIES } from "../../assets/constants/reducer.type";

export const setGalleries = (payload) => {
  return { type: SET_GALLERIES, payload };
};
